import { useState } from 'react'
import _ from 'lodash'
import moment from 'utils/moment'
import classNames from 'classnames'
import Page from 'components/Page'
import Card from 'components/Card'
// import Table from 'components/Table'
import TextArea from 'components/TextArea'
import Modal from 'components/Modal'
import Styled from './styled'
import { convertOrganizationalStructureToFilters } from 'utils/organization'
import { useTranslate } from 'hooks/translate'

import { useStoreActions, useStoreState } from 'easy-peasy'

import FilterReportStatusSelect from 'components/FilterReportStatusSelect'
import SearchOrganization from 'components/SearchOrganization'
import {
  createMonthlyConfirmationTaskApi,
  createMonthlyTrackingResultApi,
} from 'services/monthlyReview'

import { Row, Col, Form, Button, DatePicker, Space, Typography, Checkbox, Input, Table } from 'antd'

const { MonthPicker } = DatePicker

const DATE_FORMAT = 'YYYY-MM-DD'
const MONTH_FORMAT = 'MMM'
const MONTH_YEAR = 'MMM-YYYY'
const YEAR_FORMAT = 'YY'
const YEAR_MONTH_FORMAT = 'YYYY-MM'
const DEFAULT_PAGE_SIZE = 10

export default function PageMonthlyReview () {
  const { loading, monthlyReviewFilters, monthlyReviewList } = useStoreState(
    (store) => store.monthlyDashboard
  )

  const [dateTime, setDateTime] = useState('')
  const {
    getMonthlyReviewThunk,
    setMonthlyReviewFilters,
    setIcPeriodFilters,
    setIcDateFilters,
    setIcReportTypeNumberFilters,
    setIcRemoveIncidentFilters,
  } = useStoreActions((store) => store.monthlyDashboard)

  const { t } = useTranslate()

  const [editMode, setEditMode] = useState(false)
  const user = JSON.parse(localStorage.getItem('user'))
  const role_name = user.profile.role.role_name

  const [disableEditMode, setDisableEditMode] = useState(role_name == 'Risk Analyst' ? false : true)

  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const [oldDataSource, setOldDataSource] = useState([])
  const [currentDataSource, setCurrentDataSource] = useState([])

  const [filters, setFilters] = useState({
    param: null,
    page: 1,
    size: DEFAULT_PAGE_SIZE,
  })

  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [showAssignMonthlyConfirmationTaskModal, setShowAssignMonthlyConfirmationTaskModal] =
    useState(false)

  const selectedDataSource = _.filter(monthlyReviewList.items, (currentData) => {
    return _.includes(selectedRowKeys, currentData.key)
  })

  const saveMonthlyTrackingResultApi = async () => {
    let saveData = []
    currentDataSource.map((item) => {
      if (
        item.monthly_tracking_result != null ||
        item.monthly_tracking_result?.risk_analyst_comment ||
        item.monthly_tracking_result?.risk_analyst_result
      ) {
        saveData.push({
          ...item.monthly_tracking_result,
          datemonth_dt: moment(dateTime).format('YYYY-MM-5'),
        })
      }
    })

    createMonthlyTrackingResultApi(saveData)
  }

  const handleSubmit = async (event) => {
    const reporter = [
      'reporter_company_id',
      'reporter_group_id',
      'reporter_bu_id',
      'reporter_division_id',
      'reporter_department_id',
      'reporter_section_id',
    ]
    const reporterFilters = convertOrganizationalStructureToFilters(
      event.reporter_company_id,
      reporter
    )
    const nextOrgFilters = convertOrganizationalStructureToFilters(event.risk_owner_company_id)
    const nextOrgFilters_risk_co = convertOrganizationalStructureToFilters(event.risk_co_company_id)
    setDateTime(
      filters.start_date
        ? moment(filters.start_date).startOf('month').format(DATE_FORMAT)
        : moment().startOf('month').format(DATE_FORMAT)
    )
    //console.log('Event :' + JSON.stringify(event, null, ' '))
    setMonthlyReviewFilters({
      ...monthlyReviewFilters,
      ...event,
      start_date: filters.start_date
        ? moment(filters.start_date).startOf('month').format(DATE_FORMAT)
        : moment().startOf('month').format(DATE_FORMAT),
      end_date: filters.start_date
        ? moment(filters.start_date).endOf('month').format(DATE_FORMAT)
        : moment().endOf('month').format(DATE_FORMAT),
      risk_owner_company_id: nextOrgFilters?.company_id,
      risk_owner_group_id: nextOrgFilters?.group_id,
      risk_owner_bu_id: nextOrgFilters?.bu_id,
      risk_owner_division_id: nextOrgFilters?.division_id,
      risk_owner_department_id: nextOrgFilters?.department_id,
      risk_owner_section_id: nextOrgFilters?.section_id,
      risk_co_company_id: nextOrgFilters_risk_co?.company_id,
      risk_co_group_id: nextOrgFilters_risk_co?.group_id,
      risk_co_bu_id: nextOrgFilters_risk_co?.bu_id,
      risk_co_division_id: nextOrgFilters_risk_co?.division_id,
      risk_co_department_id: nextOrgFilters_risk_co?.department_id,
      risk_co_section_id: nextOrgFilters_risk_co?.section_id,
      ...reporterFilters,
    })

    //console.log('monthlyReviewFilters :' + JSON.stringify(monthlyReviewFilters, null, ' '))

    await getMonthlyReviewThunk(monthlyReviewFilters)
    await clearSelector()
  }

  const fetchDataTable = async () => {
    await getMonthlyReviewThunk(monthlyReviewFilters)
    await clearSelector()
  }

  const onCreateTaskHandler = async (event) => {
    //console.log("selectedDataSource: " + JSON.stringify(selectedDataSource, null, ''))
    //console.log("monthlyReviewFilters: " + JSON.stringify(monthlyReviewFilters, null, ''))

    const date = monthlyReviewFilters?.start_date

    // console.log(event)

    //console.log("date: " + date);

    // const is_pool_org_code = selectedDataSource?.[0]?.is_pool_org_code

    // console.log("is_pool_org_code: " + is_pool_org_code)
    // console.log("selectedDataSource: " + JSON.stringify(selectedDataSource, null, ' '))

    // const task_name = `${is_pool_org_code} Monthly Confirmation ${moment(date, DATE_FORMAT)
    //   .format(MONTH_FORMAT)
    //   .toUpperCase()}${moment(date, DATE_FORMAT).format(YEAR_FORMAT)}`

    // console.log("selectedDataSource: " + JSON.stringify(selectedDataSource, null, ' '))

    const task_due_date = moment(date, DATE_FORMAT)
      .startOf('month')
      .add(1, 'M')
      .add(4, 'days')
      .format(DATE_FORMAT)

    const task_description = `ยืนยันสถานะการรายงานประจำเดือน ${moment(date, DATE_FORMAT)
      .format(MONTH_YEAR)
      .toUpperCase()} โปรดเปลี่ยนสถานะเป็น Done ก่อนวันที่ 5 ${moment(date, DATE_FORMAT)
      .startOf('month')
      .add(1, 'M')
      .add(4, 'days')
      .format(MONTH_YEAR)
      .toUpperCase()}`

    const start_date = moment(date, DATE_FORMAT).startOf('month').add(1, 'M').format(DATE_FORMAT)

    let tasks = selectedDataSource
      .filter((item) => {
        return item.count_header == 0
      })
      .map((task, index) => {
        return {
          report_header_id: null, // null
          parent_task_id: null, // null
          start_date: start_date, // 1st of next month
          task_name: `${task.is_pool_org_code_name} Monthly Confirmation ${moment(date, DATE_FORMAT)
            .format(MONTH_FORMAT)
            .toUpperCase()}${moment(date, DATE_FORMAT).format(YEAR_FORMAT)}`, // Monthly Confirmation DEC21
          task_description: task_description,
          task_assignee_id: task.user_id, // user_id
          task_due_date: task_due_date, // 5th of next month
          task_type_id: 21, // 21
          task_status_id: 25, // 25
          task_priority_id: 23, // 23
          task_result: null, // null
        }
      })

    // console.log('tasks: ' + JSON.stringify(tasks, null, ' '))
    await createMonthlyConfirmationTaskApi(tasks)

    // close modal
    setShowAssignMonthlyConfirmationTaskModal(false)

    // fetch data
    fetchDataTable(event)
    // clear selected
    setSelectedRowKeys([])
  }

  const clearSelector = () => {
    setIcDateFilters([])
    setIcPeriodFilters('monthly')
    setIcReportTypeNumberFilters([])
    setIcRemoveIncidentFilters([])
  }

  const columns = [
    {
      title: t('Risk Co'),
      dataIndex: 'employee',
      key: 'employee_name',
      width: '20%',
      sorter: (a, b) => a.employee.employee_name_th.localeCompare(b.employee.employee_name_th),
      render: (employee, record) => {
        return {
          props: {
            style: {
              background:
                record?.task_type?.task_status?.value_list_name === 'Done' ||
                +record?.count_header > 0
                  ? '#e3ffef'
                  : '',
            },
          },
          children: (
            <div>
              <Typography.Text>{employee?.employee_name_th}</Typography.Text>
            </div>
          ),
        }
      },
    },
    {
      title: t('Risk Owner'),
      dataIndex: 'is_pool_org_code',
      key: 'is_pool_org_code',
      width: '20%',
      sorter: (a, b) => a.is_pool_org_code.localeCompare(b.is_pool_org_code),
      render: (count_header, record) => {
        return {
          props: {
            style: {
              background:
                record?.task_type?.task_status?.value_list_name === 'Done' ||
                +record?.count_header > 0
                  ? '#e3ffef'
                  : '',
            },
          },
          children: (
            <div>
              <Typography.Text>{count_header}</Typography.Text>
            </div>
          ),
        }
      },
    },
    {
      title: t('Total Report'),
      dataIndex: 'count_header',
      key: 'count_header',
      // width: '10%',
      sorter: (a, b) => {
        return a.count_header - b.count_header
      },
      render: (count_header, record) => {
        return {
          props: {
            style: {
              background:
                record?.task_type?.task_status?.value_list_name === 'Done' ||
                +record?.count_header > 0
                  ? '#e3ffef'
                  : '',
            },
          },
          children: (
            <div>
              <Typography.Text>{count_header}</Typography.Text>
            </div>
          ),
        }
      },
    },
    {
      title: t('Task'),
      dataIndex: 'task_type',
      key: 'task_name',
      sorter: (a, b) =>
        `${a?.task_type?.task_name || ''}`.localeCompare(`${b?.task_type?.task_name || ''}`),

      // width: '40%',
      render: (task_type, record) => {
        return {
          props: {
            style: {
              background:
                record?.task_type?.task_status?.value_list_name === 'Done' ||
                +record?.count_header > 0
                  ? '#e3ffef'
                  : '',
            },
          },
          children: (
            <div>
              <Typography.Text>{task_type?.task_name}</Typography.Text>
            </div>
          ),
        }
      },
    },
    {
      title: t('Status'),
      dataIndex: 'task_type',
      key: 'value_list_name',
      className: 'is-status',
      // width: '10%',
      sorter: (a, b) =>
        `${a?.task_type?.task_status?.value_list_name || ''}`.localeCompare(
          `${b?.task_type?.task_status?.value_list_name || ''}`
        ),
      render: (task_type, record) => {
        return {
          props: {
            style: {
              background:
                record?.task_type?.task_status?.value_list_name === 'Done' ||
                +record?.count_header > 0
                  ? '#e3ffef'
                  : '',
            },
          },
          children: (
            <div>
              <Typography.Text>{task_type?.task_status?.value_list_name}</Typography.Text>
            </div>
          ),
        }
      },
    },
    {
      title: t('Risk Analyst Result'),
      dataIndex: ['monthly_tracking_result', 'risk_analyst_result'],
      key: 'risk_analyst_result',
      // width: '5%',
      sorter: (a, b) =>
        `${a?.monthly_tracking_result?.risk_analyst_result || ''}`.localeCompare(
          `${b?.monthly_tracking_result?.risk_analyst_result || ''}`
        ),
      render: (risk_analyst_result, record) => {
        return (
          <Row justify='center'>
            <Checkbox
              onChange={(value, text) => {
                let temp_data = currentDataSource.map((item) => {
                  if (item.key == record.key) {
                    if (item.monthly_tracking_result == null) {
                      item.monthly_tracking_result = {
                        datemonth_dt: moment(dateTime).format('YYYY-MM-5'),
                        risk_analyst_comment: null,
                        risk_analyst_result: value.target.checked,
                        risk_coordinator_id: record.key,
                      }
                    } else {
                      item.monthly_tracking_result = {
                        ...item.monthly_tracking_result,
                        risk_analyst_result: value.target.checked,
                      }
                    }
                    return item
                  } else {
                    return item
                  }
                })
                setCurrentDataSource(temp_data)
              }}
              checked={record?.monthly_tracking_result?.risk_analyst_result}
              disabled={!editMode}
            />
          </Row>
        )
      },
    },
    {
      title: t('Risk Analyst Comment'),
      dataIndex: ['monthly_tracking_result', 'risk_analyst_comment'],
      key: 'risk_analyst_comment',
      width: 200,
      sorter: (a, b) =>
        `${a?.monthly_tracking_result?.risk_analyst_comment || ''}`.localeCompare(
          `${b?.monthly_tracking_result?.risk_analyst_comment || ''}`
        ),
      render: (risk_analyst_comment, record) => {
        return (
          <TextArea
            onChange={(value) => {
              let temp_data = currentDataSource.map((item) => {
                if (item.key == record.key) {
                  if (item.monthly_tracking_result == null) {
                    item.monthly_tracking_result = {
                      datemonth_dt: moment(filters.start_date).format('YYYY-MM-5'),
                      risk_analyst_comment: value.target.value,
                      risk_analyst_result: false,
                      risk_coordinator_id: record.key,
                    }
                  } else {
                    item.monthly_tracking_result = {
                      ...item.monthly_tracking_result,
                      risk_analyst_comment: value.target.value,
                    }
                  }
                  return item
                } else {
                  return item
                }
              })
              setCurrentDataSource(temp_data)
            }}
            value={record?.monthly_tracking_result?.risk_analyst_comment}
            rows={2}
            disabled={!editMode}
          />
        )
      },
    },
  ]

  const subColumn = [
    {
      title: t('Company'),
      dataIndex: 'company',
      key: 'company_name',
      render: (company) => company?.company_name,
      sorter: (a, b) => {
        return `${a?.company?.company_name || ''}`.localeCompare(
          `${b?.company?.company_name || ''}`
        )
      },
    },
    {
      title: t('Group'),
      dataIndex: 'group',
      key: 'group_name',
      render: (group) => group?.group_name,
      sorter: (a, b) => {
        return `${a?.group?.group_name || ''}`.localeCompare(`${b?.group?.group_name || ''}`)
      },
    },
    {
      title: t('BU/SBU'),
      dataIndex: 'business_unit',
      key: 'bu_name',
      render: (business_unit) => business_unit?.bu_name,
      sorter: (a, b) => {
        return `${a?.business_unit?.bu_name || ''}`.localeCompare(
          `${b?.business_unit?.bu_name || ''}`
        )
      },
    },
    {
      title: t('Division'),
      dataIndex: 'division',
      key: 'division_name',
      render: (division) => division?.division_name,
      sorter: (a, b) => {
        return `${a?.division?.division_name || ''}`.localeCompare(
          `${b?.division?.division_name || ''}`
        )
      },
    },
    {
      title: t('Department'),
      dataIndex: 'department',
      key: 'department_name',
      render: (department) => department?.department_name,
      sorter: (a, b) => {
        return `${a?.department?.department_name || ''}`.localeCompare(
          `${b?.department?.department_name || ''}`
        )
      },
    },
    {
      title: t('Section'),
      dataIndex: 'section',
      key: 'section_name',
      render: (section) => section?.section_name,
      sorter: (a, b) => {
        return `${a?.section?.section_name || ''}`.localeCompare(
          `${b?.section?.section_name || ''}`
        )
      },
    },
  ]

  // console.log('selectedDataSource: ' + JSON.stringify(selectedDataSource, null, ' '))

  return (
    <Styled className='page page-monthly-review'>
      <Page title={t('Monthly Tracking')} showSearch={false}>
        <Form
          layout='horizontal'
          colon={false}
          initialValues={{
            reporter_company_id: monthlyReviewFilters?.reporter_company_id,
            risk_co_company_id: monthlyReviewFilters?.risk_co_company_id,
            risk_owner_company_id: monthlyReviewFilters?.risk_owner_company_id,
            report_status_id: monthlyReviewFilters?.report_status_id,
            report_type_id: monthlyReviewFilters?.report_type_id,
            start_date: monthlyReviewFilters?.start_date
              ? moment(monthlyReviewFilters?.start_date)
              : moment().startOf('month'),
            end_date: monthlyReviewFilters?.end_date
              ? moment(monthlyReviewFilters?.end_date)
              : moment().endOf('month'),
          }}
          name='search'
          onFinish={handleSubmit}
        >
          <Row gutter={8}>
            <Col xs={24} lg={22}>
              <Row gutter={8}>
                <Col xs={24} lg={12}>
                  <Form.Item labelCol={{ span: 4 }} name='reporter_company_id' label='Reporter'>
                    <SearchOrganization />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item name='risk_co_company_id' label='Risk Co'>
                    <SearchOrganization />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col xs={24} lg={12}>
                  <Form.Item name='risk_owner_company_id' labelCol={{ span: 4 }} label='Risk Owner'>
                    <SearchOrganization />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={8}>
                  <Space direction='vertical'>
                    <Form.Item name='start_date' label='Month'>
                      <MonthPicker
                        allowClear={false}
                        format={YEAR_MONTH_FORMAT}
                        style={{ width: '100%' }}
                        defaultValue={moment().startOf('month')}
                        disabledDate={(current) => {
                          return (
                            moment().add(-5, 'year').add(2, 'month') >= current ||
                            moment().add('month') <= current
                          )
                        }}
                        onChange={(value) => {
                          setFilters({
                            ...filters,
                            start_date: value
                              ? moment(value).startOf('month').format(DATE_FORMAT)
                              : moment().startOf('month').format(DATE_FORMAT),
                            end_date: value
                              ? moment(value).endOf('month').format(DATE_FORMAT)
                              : moment().endOf('month').format(DATE_FORMAT),
                          })
                        }}
                      />
                    </Form.Item>
                  </Space>
                </Col>
                <Col xs={24} lg={4}>
                  <Form.Item name='report_status_id'>
                    <FilterReportStatusSelect />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col xs={24} lg={2}>
              <Button type='primary' shape='round' htmlType='submit'>
                {t('Search')}
              </Button>
            </Col>
          </Row>
        </Form>
        <Card title={t('Monthly Review')}>
          {editMode ? (
            <Row>
              <Col>
                <Button
                  type='primary'
                  onClick={() => {
                    setShowConfirmModal(true)
                    saveMonthlyTrackingResultApi()
                    setEditMode(false)
                  }}
                >
                  {t('Save')}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setSelectedRowKeys([])
                    setCurrentDataSource(oldDataSource)
                    setEditMode(false)
                  }}
                >
                  {t('Cancel')}
                </Button>
              </Col>
              <Col>
                <Button
                  className='send-task-btn'
                  type='primary'
                  shape='round'
                  onClick={() => setShowAssignMonthlyConfirmationTaskModal(true)}
                  disabled={_.isEmpty(selectedRowKeys)}
                >
                  {t('Send Task for Selection')}
                </Button>
              </Col>
            </Row>
          ) : (
            <Space size='middle'>
              <Button
                type='primary'
                disabled={disableEditMode}
                onClick={() => {
                  setEditMode(true)
                  setCurrentDataSource(monthlyReviewList.items)
                  setOldDataSource(monthlyReviewList.items)
                }}
              >
                {t('Edit Mode')}
              </Button>
              <Button
                className='send-task-btn'
                type='primary'
                shape='round'
                onClick={() => setShowAssignMonthlyConfirmationTaskModal(true)}
                disabled={_.isEmpty(selectedRowKeys)}
              >
                {t('Send Task for Selection')}
              </Button>
            </Space>
          )}
          <Table
            loading={loading}
            columns={columns}
            dataSource={monthlyReviewList.items}
            expandedRowRender={(record) => {
              return (
                <Space direction='vertical' size={0} style={{ width: '100%' }}>
                  <Table
                    loading={loading}
                    columns={subColumn}
                    dataSource={record.permission_org_structure}
                  />
                </Space>
              )
            }}
            pagination={{
              current: filters.page,
              pageSize: filters.size,
              //total,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (total) => t('Total ${total} items', { total }),
            }}
            onChange={(pagination) => {
              setFilters({
                // ...filters,
                page: pagination.current,
                size: pagination.pageSize,
              })
              //console.log('filters: ' + JSON.stringify(filters, null, ' '))
              //console.log('pagination: ' + JSON.stringify(pagination, null, ' '))
            }}
            rowSelection={{
              selectedRowKeys,
              onChange: (value) => {
                setSelectedRowKeys(value)
              },
              getCheckboxProps: (record) => {
                // console.log("record: " + JSON.stringify(record, null, ' '))
                // const status = record?.task_type?.task_status?.value_list_name
                const task_type = !!record?.task_type
                // console.log("task_type: " + JSON.stringify(task_type, null, ' '))
                return {
                  disabled: task_type, // disabled when task_type = null
                }
              },
            }}
            scroll={{ x: 1000 }}
            sticky
          />
        </Card>
      </Page>
      <Modal
        key={monthlyReviewList.key}
        width={800}
        visible={showAssignMonthlyConfirmationTaskModal}
        title={'Assign Monthly Confirmation Task'}
        onCancel={() => {
          setShowAssignMonthlyConfirmationTaskModal(false)
        }}
        footer={[
          <Button type='primary' shape='round' onClick={(event) => onCreateTaskHandler(event)}>
            {t('Create')}
          </Button>,
        ]}
      >
        <Space direction='vertical' size={0} style={{ width: '100%' }}>
          <Card>
            <Table
              loading={loading}
              columns={[
                {
                  title: t('Risk Co'),
                  dataIndex: 'employee',
                  key: 'employee_name',
                  render: (employee) => employee.employee_name_th,
                },
                {
                  title: t('Company/Group/BUSBU/Division/Department'),
                  dataIndex: 'employee',
                  key: 'organization',
                  render: (employee) => {
                    const {
                      org_structure: { company, group, business_unit, division, department },
                    } = employee
                    return `${company.company_name}/ ${group.group_name}/ ${business_unit.bu_name}/ ${division.division_name}/ ${department.department_name}`
                  },
                },
              ]}
              dataSource={selectedDataSource}
              pagination={false}
            />
          </Card>
        </Space>
      </Modal>
    </Styled>
  )
}
